import React from 'react';
import SaasFooter from './SaaSFooter';
import Footer from './Footer';
import { isSaaSSubdomain } from 'utils/getSubdomain';

const HorizontalFooter = () => {
  return isSaaSSubdomain() ? <SaasFooter /> : <Footer />;
};

export default HorizontalFooter;
